import React, { FC } from 'react'
import { useLocation } from 'react-router-dom'
import { Download } from 'lucide-react'
import { history } from 'middleware'
import { pathUtils } from 'utils/pathnameFormatter'
import PermissionRequired from 'admin/permissionRequired'
import { PageActionButton } from 'uiComponents/buttons/pageAddButton'
import { useTranslation } from 'translations'

const OrdersExportButton: FC<{ accountSlug: string }> = ({ accountSlug }) => {
    const { t } = useTranslation()
    const location = useLocation()

    return (
        <PermissionRequired accountSlug={accountSlug} name="export_orders">
            <PageActionButton
                icon={Download}
                label={t('orders.orders.ordersTable.exportTooltip')}
                onClick={() => {
                    if (!/export$/.test(location.pathname)) {
                        history.push(pathUtils.addPath(location.pathname, 'export', location.search))
                    }
                }}
                data-testid="orders-export-button"
            />
        </PermissionRequired>
    )
}

export default OrdersExportButton
